import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../../../elements/button'
import { useParams } from 'react-router-dom'
import DataSelection from '../../../../setScope/_components/uploadData/dataSelection'
import { useExperimentApi } from '../../../../../../store/api/hooks/experimentApiHook'
import toast from 'react-hot-toast'
import Loader from '../../../../../../components/loader'
import { SelectedDataTableType } from '../../../../../../_config/types'
import { trackEvent } from '../../../../../../_common/functions'
import { useExperimentSelector } from '../../../../../../store/selectors/experimentSelector'

interface Props {
    _ref: any
    onContinue: (data: any) => void
}

const RCTMultiFileMeasurementModal: React.FC<Props> = ({ _ref, onContinue }) => {
    const { t } = useTranslation()
    const params: any = useParams()
    const experimentAPI: any = useExperimentApi()
    const experiment = useExperimentSelector()
    const [working, setWorking] = useState<boolean>(false)

    const [selectedKpiMeasurementTable, setSelectedKpiMeasurementTable] = useState<SelectedDataTableType | null>(null)
    const [selectedRecMeasurementTable, setSelectedRecMeasurementTable] = useState<SelectedDataTableType | null>(null)
    const isDisabled = working || selectedKpiMeasurementTable == null || selectedRecMeasurementTable == null

    useEffect(() => {
        trackEvent('wizard_multifile_measurement_modal_opened', { experiment_literal: experiment?.experiment_literal })
    }, [])

    useEffect(() => {
        if (selectedKpiMeasurementTable) {
            trackEvent('wizard_multifile_kpi_table_selected', { experiment_literal: experiment?.experiment_literal, table_name: selectedKpiMeasurementTable?.table?.name })
        }
    }, [selectedKpiMeasurementTable])

    useEffect(() => {
        if (selectedRecMeasurementTable) {
            trackEvent('wizard_multifile_rec_table_selected', { experiment_literal: experiment?.experiment_literal, table_name: selectedRecMeasurementTable?.table?.name })
        }
    }, [selectedRecMeasurementTable])

    const updateWithMeasurementTableData = () => {
        if (onContinue) {
            const payload: any = {
                literal: params.experiment,
                delta_measurement_table_name: selectedKpiMeasurementTable?.table?.name,
                delta_recommendation_table_name: selectedRecMeasurementTable?.table?.name,
            }

            trackEvent('wizard_multifile_measurement_next_clicked', { experiment_literal: experiment?.experiment_literal })
            setWorking(true)
            experimentAPI.updateExperiment(
                payload,
                (data: any) => {
                    setWorking(false)
                    trackEvent('wizard_multifile_measurement_success', { experiment_literal: experiment?.experiment_literal })
                    onContinue({
                        kpi: selectedKpiMeasurementTable?.table?.name,
                        rec: selectedRecMeasurementTable?.table?.name,
                    })
                },
                (error: any) => {
                    setWorking(false)
                    trackEvent('wizard_multifile_measurement_failed', { experiment_literal: experiment?.experiment_literal, error_message: error?.message })
                    toast.error(error?.message)
                },
            )
        }
    }

    return (
        <dialog ref={_ref} className="modal">
            <div className="modal-box w-11/12 max-w-5xl">
                <p className="text-[1.125rem] font-bold mb-2">{t('Measurement Data Selection')}</p>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <p className="text-[1rem] text-[#0F0F0F] font-bold mb-[0.125rem]">{t('KPI Data:')}</p>
                        <p className="text-[0.79rem] text-[#676767] leading-[1.2rem] mb-2">{t('Ensure your document includes these columns: Granularity, Date, KPI, and Group for seamless data processing.')}</p>
                        <DataSelection _for="measurement" selectedDataTable={setSelectedKpiMeasurementTable} />
                    </div>

                    <div>
                        <p className="text-[1rem] text-[#0F0F0F] font-bold mb-[0.125rem]">{t('Recommendation Data:')}</p>
                        <p className="text-[0.79rem] text-[#676767] leading-[1.2rem] mb-2">{t('Ensure your document includes Granularity, Recommendations for seamless data processing.')}</p>
                        <DataSelection _for="recommendation" selectedDataTable={setSelectedRecMeasurementTable} />
                    </div>
                </div>

                <div className="flex items-center justify-end my-4 ">
                    <div className="flex items-center gap-3">
                        <Button
                            theme="secondary"
                            size="xs"
                            styleType="outline"
                            onClick={() => {
                                trackEvent('wizard_multifile_measurement_modal_closed', { experiment_literal: experiment?.experiment_literal })
                                _ref?.current?.close()
                            }}
                        >
                            {t('Cancel')}
                        </Button>
                        <Button
                            theme="secondary"
                            size="xs"
                            className="text-white"
                            disabled={isDisabled}
                            onClick={() => {
                                updateWithMeasurementTableData()
                            }}
                        >
                            {working ? <Loader /> : t('NEXT STEP')}
                        </Button>
                    </div>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button type="button">{t('close')}</button>
            </form>
        </dialog>
    )
}

export default RCTMultiFileMeasurementModal
